import { render } from "./backgroundText.vue?vue&type=template&id=5de2cdcc"
import script from "./backgroundText.vue?vue&type=script&lang=js"
export * from "./backgroundText.vue?vue&type=script&lang=js"

import "./backgroundText.vue?vue&type=style&index=0&id=5de2cdcc&lang=scss"

import exportComponent from "C:\\Users\\jekr\\Documents\\au-csmv-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__